module.exports = __webpack_public_path__ + "static/media/wallpaper.e85471c1.jpeg";